// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Fresnel$PrezzeeRibbon from "../../../bindings/Fresnel/Fresnel.bs.js";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";

var icon = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(14)),
      BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(7)),
      BsCssJs$PrezzeeRibbon.transitionProperty("transform"),
      BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.regular),
      BsCssJs$PrezzeeRibbon.transitionTimingFunction(BsCssJs$PrezzeeRibbon.cubicBezier(0.4, 0, 0.2, 1)),
      BsCssJs$PrezzeeRibbon.transitionDelay(0),
      BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.rotate(BsCssJs$PrezzeeRibbon.deg(0)))
    ]);

var iconExpanded = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.rotate(BsCssJs$PrezzeeRibbon.deg(180)))]);

var menuButtonContainer = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.flexDirection("row"),
      BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(20)),
      BsCssJs$PrezzeeRibbon.selector("a", [BsCssJs$PrezzeeRibbon.textDecoration("none")]),
      BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.firstChild([BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(10))])])
    ]);

var Styles = {
  icon: icon,
  iconExpanded: iconExpanded,
  menuButtonContainer: menuButtonContainer
};

function Auth__SignedIn(props) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      greaterThanOrEqual: "rbLargeDesktop",
                      children: JsxRuntime.jsx("div", {
                            children: props.children,
                            className: menuButtonContainer
                          })
                    }),
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      lessThan: "rbLargeDesktop",
                      children: props.menuCard
                    })
              ]
            });
}

var ProfileMenuPopover;

var make = Auth__SignedIn;

export {
  Styles ,
  ProfileMenuPopover ,
  make ,
}
/* icon Not a pure module */
